var $ = jQuery;
$(document).ready(function() {
    $('.card-variant-options').on('click', 'span.mehr', function () {
        $(this).hide();
        $(this).parent().addClass('is-open');
    });
    $(document).on('click', '.acctab_title', function(e) {
        if ($(window).width() >= 768) {
            $('.acctab_title').removeClass('active-accor');
            $(this).addClass('active-accor');
            $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
        } else {
            $('.acctab_title').removeClass('active-accor');
            $(this).addClass('active-accor');
            $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
            // $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $('.acc_tab-inner .acc-tab-content').addClass('tab-content-show').show();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
        }
    });
    $(document).on('click', '.acc_tab-inner .acc-tab-content .back__arrow', function(e) {
        $('.acc_tab-inner .acc-tab-content').removeClass('tab-content-show').show();
    });
    $('.footer-block.has-dropdown .footer-block__heading').click(function(e) {
        e.preventDefault();
        $(this).toggleClass('active');
    });
    $('.level-2 details').addClass('menu-opening').attr('open', true);
    $('.acc-head').on('click', function() {
        if ($(this).hasClass('active')) {
            $(this).siblings('.acc-content').slideUp();
            $(this).removeClass('active');
        } else {
            $('.acc-content').slideUp();
            $('.acc-head').removeClass('active');
            $(this).siblings('.acc-content').slideToggle();
            $(this).toggleClass('active');
        }
    });
    $(document).on('click', 'span.click-down svg', function(e) {
        $(this).hide();
        $('.testimonials-slider').addClass('active');
    });
    $('.collection_slider .product-grid').flickity({
        imagesLoaded: true,
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'left',
        wrapAround: true,
        prevNextButtons: false,
        percentPosition: true,
        pageDots: true,
        rightToLeft: false,
        autoPlay: 5000,
        groupCells: false
    });
    var $gallery = $('.product-single__gallery');
    var itemsCount = $gallery.find('.product-single__thumbnails-item, li, .gallery__item').length; 
    var isMobile = window.innerWidth <= 768; 
    var shouldInitSlider = (itemsCount > 1) || isMobile;

    if (shouldInitSlider) {
        $gallery.flickity({
            imagesLoaded: true,
            groupCells: false,
            dragThreshold: 5,
            cellAlign: 'center',
            wrapAround: true,
            prevNextButtons: false,
            percentPosition: true,
            pageDots: true,
            rightToLeft: false,
            autoPlay: false,
            sync: '.product-single__thumbnails'
        });

        $('.product-single__gallery').on('change.flickity', function(event, index) {
            var $thumbnails = $('.product-single__thumbnails li');
            $thumbnails.removeClass('active');
            $thumbnails.eq(index).addClass('active');
        });

        $('.product-single__thumbnails li').first().addClass('active');

        $('.product-single__thumbnails li').on('click', function() {
            var index = $(this).index();
            $('.product-single__gallery').flickity('select', index);
        });
    }

    // Scroll arrow
    var currentIndex = 0;
    $('.product__thumb-arrow--next').on('click', function () {
        var $items = $('.product-single__thumbnails-item');
        var $list  = $('.product-single__thumbnails');

        currentIndex++;
        if (currentIndex >= $items.length) {
            currentIndex = $items.length - 1;
            return;
        }

        var $nextItem = $items.eq(currentIndex);
        $list.animate({
            scrollTop: $nextItem.position().top + $list.scrollTop() - 20
        }, 300);
    });
    //initFlickityMobile
    function initFlickityMobile() {
        var $lists = $(".announcement-bar .slider--everywhere,.icons-footer .icon-text-wrapper");
        var $lists_dots = $(".icons_page .icon-text-wrapper,.collection-list-wrapper .grid,.tzn-player__grid");
        var $lists_dots_center = $(".testimonials-slider");
        if ($(window).width() < 950) {
            $lists.each(function() {
                if (!$(this).data('flickity')) {
                    $(this).flickity({
                        pageDots: false,
                        freeScroll: false,
                        wrapAround: true,
                        prevNextButtons: false,
                        autoPlay: 3000,
                        groupCells: false,
                        cellAlign: 'center'
                    });
                }
            });
            $lists_dots.each(function() {
                if (!$(this).data('flickity')) {
                    $(this).flickity({
                        pageDots: true,
                        freeScroll: false,
                        wrapAround: true,
                        prevNextButtons: false,
                        autoPlay: 5000,
                        groupCells: false,
                        cellAlign: 'left'
                    });
                }
            });
            $lists_dots_center.each(function() {
                if (!$(this).data('flickity')) {
                    $(this).flickity({
                        pageDots: true,
                        freeScroll: false,
                        wrapAround: true,
                        prevNextButtons: false,
                        autoPlay: 5000,
                        groupCells: true,
                        cellAlign: 'center'
                    });
                }
            });
        } else {
            $lists.each(function() {
                if ($(this).data('flickity')) {
                    $(this).flickity('destroy');
                }
            });
            $lists_dots.each(function() {
                if ($(this).data('flickity')) {
                    $(this).flickity('destroy');
                }
            });
            $lists_dots_center.each(function() {
                if ($(this).data('flickity')) {
                    $(this).flickity('destroy');
                }
            });
        }
    }
    $(document).ready(initFlickityMobile);
    $(window).on('resize', initFlickityMobile);
});
document.addEventListener('change', function (e) {
  if (!e.target.matches('.card-variant-option input')) return;

  const wrapper = e.target.closest('.custom-card-variant');
  if (!wrapper) return;

  const hiddenInput = wrapper.querySelector('.product-variant-id');
  if (hiddenInput) {
    hiddenInput.value = e.target.value;
  }
});
/*** LOAD MORE **/
$(document).on('click', '[data-pagination-link]', function(e) {
    e.preventDefault();
    const $button = $(this);
    const nextUrl = $button.attr('href');

    $button.text("Laden...");
    $button.prop('disabled', true);

    $.get(nextUrl, function(response) {
        const $tempDiv = $('<div>').html(response);
        const newProductsHtml = $tempDiv.find('#product-grid').html();
        const $newButton = $tempDiv.find('[data-pagination-link]');

        $('ul#product-grid').append(newProductsHtml);
        $button.closest('.show_more_btn').remove(); // remove old button wrapper

        if ($newButton.length) {
            $('ul#product-grid').after($newButton.closest('.show_more_btn')); // add new button wrapper
        }
    }).fail(function() {
        console.error('Error loading more products.');
        $button.text("Try again");
        $button.prop('disabled', false);
    });
    
});

